export default {
  sidebar: {
    bundle: 'Bundle',
    package: 'Package',
    dependency: 'Dependency',
  },
};
